<template>
  <v-container>
    <v-row>
      <v-col cols='12'>
        <v-data-table
          :headers='headers'
          :items='workflows'
          class='elevation-1'
          :search="search"
          :loading='loading'
          :loading-text="$t('keywords.loading')"
          :items-per-page="itemsPerPage"
          @update:items-per-page=" v => itemsPerPage = v"
        >
          <template v-slot:top>
            <v-toolbar flat color='white'>
              <v-toolbar-title>{{ $t("keywords.listing") }}</v-toolbar-title>
              <v-divider class='mx-4' inset vertical></v-divider>
              <v-btn color='primary' dark class='mb-2' @click="editItem(null)">{{ $t("button.new") }}</v-btn>
              <ImportExportWorkflow @import="searchAll()" />
            </v-toolbar>

            <SearchField v-model="search" />
          </template>

          <template v-slot:item.lastModified='{ item }'>
            <LastModify :date="item.lastModified" :by="item.lastModifiedBy" />
          </template>

          <template v-slot:item.actions='{ item }'>
            <v-tooltip bottom>
              <template v-slot:activator='{ on }'>
                <v-icon v-on="on" color="primary" small class='mr-2' @click='tryPlay(item)'>mdi-animation-play</v-icon>
              </template>
              <span>{{ $t('button.play') }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator='{ on }'>
                <v-icon v-on="on" color="orange" small class='mr-2' @click='editItem(item)'>mdi-pencil</v-icon>
              </template>
              <span>{{ $t('button.edit') }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator='{ on }'>
                <v-icon v-on="on" color="red" small class='mr-2' @click='confirmaDeleteItem(item)'>mdi-delete</v-icon>
              </template>
              <span>{{ $t('button.delete') }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator='{ on }'>
                <v-icon v-on="on" color="secondary" small class='mr-2' @click='exportItem(item)'>mdi-export</v-icon>
              </template>
              <span>{{ $t('core.import_export.export') }}</span>
            </v-tooltip>
            <v-tooltip bottom v-if="item.workflowDescription">
              <template v-slot:activator='{ on }'>
                <v-icon v-on="on" color="info" small class='mr-2' @click='showDialogDescricao(item)'>mdi-information-outline</v-icon>
              </template>
              <span>{{ $t('keywords.description') }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator='{ on }'>
                <ShowLastLogsIcon v-on="on" :integrationName="item.workflowName" processType="workflow" />
              </template>
              <span v-text="$t('keywords.latest_logs')" />
            </v-tooltip>
          </template>

          <template v-slot:item.integrationType='{ item }'>
            <p v-if="item.integrationType">{{item.integrationType}}</p>
            <v-icon small color="darkgrey" v-else>mdi-blur</v-icon>
          </template>

          <template v-slot:item.active='{ item }'>
            <v-icon small color="green" v-if="item.active">mdi-circle</v-icon>
            <v-icon small color="darkgrey" v-else>mdi-circle</v-icon>
          </template>

          <template v-slot:item.workflowName='{ item }'>
            <p class="bold" v-if="item.workflowName">{{item.workflowName}}</p>
            <v-icon small color="darkgrey" v-else>mdi-blur</v-icon>
          </template>

          <template v-slot:item.nameGetParameters='{ item }'>
            <v-chip v-for="par in item.parametros"
              :key="par"
              class="mr-2"
            >
              {{par}}
            </v-chip>
          </template>

          <template v-slot:no-data>
            {{ $t("warnings.no_data_found") }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-row>
      <v-dialog v-model="bodyDialog" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">{{ $t("workflow.grid.fill_workflow_body") }}</span>
          </v-card-title>
          <v-card-text>
            <v-textarea v-model="bodyContent" rows="5" outlined>
            </v-textarea>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="gray darken-1" text @click="bodyDialog = false">{{ $t('button.cancel') }}</v-btn>
            <v-btn color="primary darken-1" text @click="tryPlayDialogReturn">{{ $t('button.send') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <DeleteDialog :dialog="this.itemToExclude != null" type="Workflow" :name="getExcludeWorkflowName"  @Cancel="itemToExclude = null" @Comfirm="deleteItem()" />
    <ShowDialog :dialog="this.itemDescription != null" type="Workflow" :detailText="getDescriptionWorkflow" :name="getExcludeWorkflowName"  @Cancel="itemDescription = null,itemToExclude = null" @Comfirm="deleteItem()" />
  </v-container>
</template>

<script>
import ImportExportService from '@/services/ImportExportService'
import workflowService from '@/services/WorkflowService'
import Vue from 'vue'
import VueCookies from 'vue-cookies'
import LocalStorageService from '../../services/LocalStorageService'
import LastModify from '../core/LastModify.vue'
import SearchField from '../core/SearchField.vue'
import ShowLastLogsIcon from '../core/ShowLastLogsIcon.vue'
import DeleteDialog from './../core/DeleteDialog'
import ShowDialog from './../core/ShowDialog'
import ImportExportWorkflow from './ImportExportWorkflow.vue'

Vue.use(VueCookies)

export default {
  components: {
    DeleteDialog,
    ShowDialog,
    ShowLastLogsIcon,
    LastModify,
    SearchField,
    ImportExportWorkflow
  },
  name: 'workflowGrid',
  data: () => ({
    workflows: [],
    bodyContent: '',
    bodyDialog: false,
    workflowToPlay: null,
    itemToExclude: null,
    itemDescription: null,
    search: '',
    loading: true
  }),

  created () {
    this.searchAll()
  },
  computed: {

    version () { return this.$versionable.versions.workflow },

    getExcludeWorkflowName () {
      if (this.itemToExclude) {
        return this.itemToExclude.workflowName
      }
      return ''
    },

    getDescriptionWorkflow () {
      if (this.itemDescription) {
        return this.itemDescription.workflowDescription
      }
      return ''
    },
    firstItem () {
      // the index of the item that is the top row displayed on the screen
      return this.pagination.pageStart
    },
    itemsPerPage: {
      get () {
        return this.$cookies.isKey('workflow_per_page') ? parseInt(this.$cookies.get('workflow_per_page')) : 10
      },
      set (value) {
        this.$cookies.set('workflow_per_page', value)
      }
    },
    headers () {
      return [
        {
          text: this.$t('keywords.workflow'),
          value: 'workflowName',
          sortable: true,
          align: 'start',
          filterable: true
        },
        {
          text: this.$t('keywords.last_modify'),
          value: 'lastModified',
          sortable: true,
          show: this.version > '1.0.0'
        },
        {
          text: this.$t('check.active'),
          value: 'active',
          sortable: true,
          align: 'center'
        },
        {
          text: this.$t('keywords.type'),
          value: 'integrationType',
          sortable: true
        },
        {
          text: this.$t('workflow.grid.consecutive_failures'),
          value: 'consecutiveFailureCount',
          sortable: true,
          align: 'center',
          show: this.version > '1.0.0' && LocalStorageService.isPlatform()
        },
        {
          text: this.$t('keywords.actions'),
          value: 'actions',
          sortable: false,
          align: 'center'
        }
      ].filter(h => h.show ?? true)
    }
  },

  methods: {
    tryPlay (workflow) {
      this.workflowToPlay = workflow
      if (this.workflowToPlay.integrationType === 'REST' && this.workflowToPlay.starterAction && this.workflowToPlay.starterAction.restMethod !== 'GET') {
        this.bodyContent = '{\n\n}'
        this.bodyDialog = true
      } else {
        this.playWorkflow(this.workflowToPlay, this.bodyContent)
      }
    },
    tryPlayDialogReturn () {
      this.bodyDialog = false
      this.playWorkflow(this.workflowToPlay, this.bodyContent)
    },

    playWorkflow (workflow, bodyContent) {
      workflowService.play(workflow.workflowName, { bodyContent })
        .then(response => {
          this.$message.success(this.$t('warnings.success.init'))
          this.showLog(response.data)
        })
        .catch(error => this.$message.error(`${this.$t('warnings.error.init')} : ${error}`))
    },

    showLog (query) {
      const { uniqueId, date, identifier, processType } = query
      this.$versionable.decorators.monitoring.showLog(uniqueId, date, identifier, processType)
    },

    searchAll () {
      this.workflows = []
      this.$versionable.decorators.workflow.findAll()
        .then(({ data }) => {
          this.workflows = data
          this.loading = false
        })
    },

    editItem (item) {
      this.$emit('editItem', false, item)
    },

    confirmaDeleteItem (item) {
      this.itemToExclude = item
    },

    showDialogDescricao (item) {
      this.itemDescription = item
      this.itemToExclude = item
    },

    deleteItem () {
      workflowService.delete(this.itemToExclude.workflowName)
        .then((response) => {
          this.searchAll()
          this.itemToExclude = null
        })
    },

    exportItem (item) {
      if (confirm(this.$t('warnings.confirm.export'))) {
        ImportExportService.export('workflows', item.workflowName)
          .then(() => this.$message.success(this.$t('warnings.success.export')))
          .catch(error => this.$message.error(`${this.$t('warnings.error.export')} : ${error}`))
      }
    }
  }

}

</script>

<style scoped>
.bold{
  font-weight: bold;
}
</style>
